import { Uketsuke } from "@/model/Uketsuke";
import { SknUketsukeExtends } from "@/model/SknUketsukeExtends";
import { Customer, CustomerCar } from "@/model/ReservationDetail";
import { Support } from "@/model/Support";
export default class State {
  isLoadUketsuke: boolean;

  uketsukeCd: string;
  uketsukeExtendsId: number | null;
  yoyakuNo: string;

  uketsuke: Uketsuke;
  sknUketsukeExtends: SknUketsukeExtends;
  customer: Customer;
  customerCar: CustomerCar;
  support: Support[];
  frontStaff: string;
  isStart: boolean;
  estIssueAt: string;

  constructor() {
    this.isLoadUketsuke = false;
    this.support = [];
    this.frontStaff = "";
    this.uketsukeCd = "";
    this.uketsukeExtendsId = null;
    this.yoyakuNo = "";
    this.sknUketsukeExtends = {};
    this.isStart = false;
    this.uketsuke = {};
    this.estIssueAt = "";
    this.customer = {};
    this.customerCar = {};
  }
}
